module.exports = __webpack_public_path__ + "images/style-3-aeb59a2b6b24dd7af1e92ad3de2965a3.jpg";